module.exports = __webpack_public_path__ + "img/5.6a0f2217.jpg";